export const trial = {
  // Landing page
  'trial.cta.tryFree': 'Essayer gratuitement',
  'trial.cta.tryFreeSubtitle': '30 jours gratuits, sans engagement',

  // Trial badge
  'trial.badge.active': 'Essai gratuit',
  'trial.badge.daysRemaining': '{days} jours restants',
  'trial.badge.expired': 'Essai expiré',

  // Trial info
  'trial.info.title': 'Essai gratuit de 30 jours',
  'trial.info.description': 'Testez SubventionPilot sans engagement avec toutes les fonctionnalités essentielles.',
  'trial.info.features.clients': 'Jusqu\'à 3 profils clients',
  'trial.info.features.search': 'Recherche illimitée de subventions',
  'trial.info.features.ai': 'Assistant IA inclus',
  'trial.info.features.export': 'Export des données',
  'trial.info.noCard': 'Aucune carte bancaire requise',

  // Client limit reached modal
  'trial.limit.title': 'Limite de l\'essai gratuit atteinte',
  'trial.limit.description': 'Vous avez atteint la limite de {limit} profils clients de votre essai gratuit.',
  'trial.limit.currentCount': 'Profils clients actuels : {count}/{limit}',
  'trial.limit.upgradePrompt': 'Pour ajouter plus de clients et accéder à toutes les fonctionnalités, passez à un abonnement.',
  'trial.limit.upgradeButton': 'Passer à l\'abonnement',
  'trial.limit.later': 'Plus tard',

  // Trial expired modal
  'trial.expired.title': 'Votre essai gratuit a expiré',
  'trial.expired.description': 'Votre période d\'essai de 30 jours est terminée. Pour continuer à utiliser SubventionPilot, veuillez choisir un abonnement.',
  'trial.expired.upgradeButton': 'Choisir un abonnement',
  'trial.expired.dataKept': 'Vos données sont conservées pendant 30 jours.',

  // Trial banner (dashboard)
  'trial.banner.title': 'Essai gratuit',
  'trial.banner.daysLeft': '{days} jours restants sur votre essai',
  'trial.banner.clientsUsed': '{used}/{limit} profils clients utilisés',
  'trial.banner.upgradeNow': 'Passer à l\'abonnement',

  // Onboarding trial step
  'trial.onboarding.title': 'Démarrer votre essai gratuit',
  'trial.onboarding.subtitle': '30 jours pour découvrir SubventionPilot',
  'trial.onboarding.benefit1.title': '3 profils clients',
  'trial.onboarding.benefit1.description': 'Créez jusqu\'à 3 profils pour tester la plateforme',
  'trial.onboarding.benefit2.title': 'Accès complet',
  'trial.onboarding.benefit2.description': 'Toutes les fonctionnalités de recherche et d\'analyse',
  'trial.onboarding.benefit3.title': 'Sans engagement',
  'trial.onboarding.benefit3.description': 'Aucune carte bancaire requise pour commencer',
  'trial.onboarding.startButton': 'Commencer l\'essai gratuit',

  // Multi-user restriction
  'trial.multiuser.title': 'Fonctionnalité réservée aux abonnés',
  'trial.multiuser.description': 'L\'invitation de membres d\'équipe n\'est pas disponible pendant l\'essai gratuit.',
  'trial.multiuser.upgradePrompt': 'Passez à un abonnement pour inviter des collaborateurs.',
} as const;
